module.exports = __webpack_public_path__ + "img/direct-access.31375b50.svg";